// import React from "react";

// type WalletSummaryProps = {
//   formData: {
//     businessName: string;
//     walletDisplayName: string;
//     businessType: string;
//     country: string;
//     currency: string;
//   };
//   pinData: {
//     newPin: string;
//     confirmNewPin: string;
//   };
//   bankData: {
//     accountName: string;
//     bankName: string;
//     accountNumber: string;
//   };
//   isLoading: boolean;
//   onBack: () => void;
//   onConfirm: () => void;
// };

// const WalletSummary: React.FC<WalletSummaryProps> = ({
//   formData,
//   pinData,
//   bankData,
//   isLoading,
//   onBack,
//   onConfirm,
// }) => {
//   return (
//     <div className="bg-white rounded-2xl border border-gray-200 p-8">
//       <div className="mb-8">
//         <h2 className="text-[16px] md:text-[20px] font-semibold text-fleetblue mb-2">
//           Wallet Summary
//         </h2>
//         <p className="text-gray-500 text-sm border-b border-gray-200 pb-4">
//           Review if your details were entered correctly
//         </p>
//       </div>

//       <div className="space-y-6 mb-10">
//         {/* Wallet Name */}
//         {/* <div className="flex py-2">
//           <span className="text-[#1D1D1D] font-medium w-[50%]">
//             Wallet Name:
//           </span>
//           <span className="text-fleetblack w-[50%]">
//             {formData.walletDisplayName}
//           </span>
//         </div> */}

//         {/* Wallet Type */}
//         {/* <div className="flex py-2">
//           <span className="text-[#1D1D1D] font-medium w-[50%]">
//             Wallet Type:
//           </span>
//           <span className="text-fleetblack capitalize w-[50%]">
//             {formData.businessType}
//           </span>
//         </div> */}

//         {/* Linked Account */}
//         <div className="flex py-2">
//           <span className="text-[#1D1D1D] font-medium w-[50%]">
//             Linked Account:
//           </span>
//           <span className="text-fleetblack w-[50%]">
//             {bankData.bankName} - ****{bankData.accountNumber.slice(-4)}
//           </span>
//         </div>

//         {/* Security PIN */}
//         <div className="flex py-2">
//           <span className="text-[#1D1D1D] font-medium w-[50%]">
//             Security PIN:
//           </span>
//           <span className="text-fleetblack w-[50%]">****</span>
//         </div>

//         {/* Currency */}
//         {/* <div className="flex py-2">
//           <span className="text-[#1D1D1D] font-medium w-[50%]">Currency</span>
//           <span className="text-fleetblack w-[50%]">{formData.currency}</span>
//         </div> */}
//       </div>

//       {/* Buttons */}
//       <div className="flex justify-end gap-4 mt-10">
//         {/* Back Button */}
//         <button
//           className="px-6 py-2 bg-transparent text-fleetblue rounded-lg flex items-center border border-fleetblue "
//           onClick={onBack}
//         >
//           <svg
//             xmlns="http://www.w3.org/2000/svg"
//             fill="none"
//             viewBox="0 0 24 24"
//             stroke="currentColor"
//             className="w-5 h-5 mr-2"
//           >
//             <path
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               strokeWidth="2"
//               d="M19 12H5m0 0l7-7m-7 7l7 7"
//             />
//           </svg>
//           Back
//         </button>

//         {/* Confirm Button */}
//         <button
//           className={`px-6 py-2 rounded-[8px] flex items-center justify-center ${
//             !isLoading
//               ? "bg-fleetblue text-white"
//               : "bg-fleetinactiveblue text-[#D0D7E7]"
//           }`}
//           onClick={onConfirm}
//         >
//           {isLoading ? "Creating Wallet..." : "Confirm & Create Wallet"}
//           <svg
//             xmlns="http://www.w3.org/2000/svg"
//             fill="none"
//             viewBox="0 0 24 24"
//             stroke="currentColor"
//             className="w-5 h-5 ml-2"
//           >
//             <path
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               strokeWidth="2"
//               d="M5 12h14m0 0l-5-5m5 5l-5 5"
//             />
//           </svg>
//         </button>
//       </div>
//     </div>
//   );
// };
// export default WalletSummary;



import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

type WalletSummaryProps = {
  formData: {
    businessName: string;
    walletDisplayName: string;
    businessType: string;
    country: string;
    currency: string;
  };
  pinData: {
    newPin: string;
    confirmNewPin: string;
  };
  bankData: {
    accountName: string;
    bankName: string;
    accountNumber: string;
    bvn: string;
  };
  isLoading: boolean;
  onBack: () => void;
  onConfirm: () => void;
};

const MaskedField: React.FC<{
  label: string;
  value: string;
  visibleChars?: number; // how many trailing chars to show when masked
  maskChar?: string;
}> = ({ label, value, visibleChars = 4, maskChar = "*" }) => {
  const [visible, setVisible] = useState(false);

  const masked =
    value.length > visibleChars
      ? maskChar.repeat(value.length - visibleChars) + value.slice(-visibleChars)
      : maskChar.repeat(value.length);

  return (
    <div className="flex py-3 border-b border-gray-100 last:border-0 items-center">
      <span className="text-[#1D1D1D] font-medium w-[50%]">{label}:</span>
      <div className="flex items-center gap-2 w-[50%]">
        <span className="text-fleetblack font-mono tracking-wider">
          {visible ? value : masked}
        </span>
        <button
          type="button"
          onClick={() => setVisible((v) => !v)}
          className="text-gray-400 hover:text-[#143887] transition-colors flex-shrink-0"
        >
          {visible ? <EyeOff size={16} /> : <Eye size={16} />}
        </button>
      </div>
    </div>
  );
};

const WalletSummary: React.FC<WalletSummaryProps> = ({
  formData,
  pinData,
  bankData,
  isLoading,
  onBack,
  onConfirm,
}) => {
  return (
    <div className="bg-white rounded-2xl border border-gray-200 p-8">
      <div className="mb-8">
        <h2 className="text-[16px] md:text-[20px] font-semibold text-fleetblue mb-2">
          Wallet Summary
        </h2>
        <p className="text-gray-500 text-sm border-b border-gray-200 pb-4">
          Review if your details were entered correctly
        </p>
      </div>

      <div className="space-y-1 mb-10">

        {/* Bank Name — plain, no need to hide */}
        <div className="flex py-3 border-b border-gray-100 items-center">
          <span className="text-[#1D1D1D] font-medium w-[50%]">Bank Name:</span>
          <span className="text-fleetblack w-[50%]">{bankData.bankName || "—"}</span>
        </div>

        {/* Account Number — show last 4 by default */}
        <MaskedField
          label="Account Number"
          value={bankData.accountNumber}
          visibleChars={4}
        />

        {/* Account Name — plain, no need to hide */}
        <div className="flex py-3 border-b border-gray-100 items-center">
          <span className="text-[#1D1D1D] font-medium w-[50%]">Account Name:</span>
          <span className="text-fleetblack w-[50%]">{bankData.accountName || "—"}</span>
        </div>

        {/* BVN — show last 4 by default */}
        <MaskedField
          label="BVN"
          value={bankData.bvn}
          visibleChars={4}
        />

        {/* Security PIN — fully masked */}
        <MaskedField
          label="Security PIN"
          value={pinData.newPin}
          visibleChars={8}
        />
      </div>

      {/* Buttons */}
      <div className="flex justify-end gap-4 mt-10">
        {/* Back Button */}
        <button
          className="px-6 py-2 bg-transparent text-fleetblue rounded-lg flex items-center border border-fleetblue"
          onClick={onBack}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            className="w-5 h-5 mr-2"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M19 12H5m0 0l7-7m-7 7l7 7"
            />
          </svg>
          Back
        </button>

        {/* Confirm Button */}
        <button
          className={`px-6 py-2 rounded-[8px] flex items-center justify-center ${
            !isLoading
              ? "bg-fleetblue text-white"
              : "bg-fleetinactiveblue text-[#D0D7E7]"
          }`}
          onClick={onConfirm}
          disabled={isLoading}
        >
          {isLoading ? "Creating Wallet..." : "Confirm & Create Wallet"}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            className="w-5 h-5 ml-2"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M5 12h14m0 0l-5-5m5 5l-5 5"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default WalletSummary;